import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsApi } from '../services/api';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ whatsappNumber: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const data = await settingsApi.getPublic();
        const rawNumber = data.whatsappNumber || null;
        const cleanNumber = rawNumber ? rawNumber.replace(/\s/g, '').replace(/^\+/, '') : null;
        setSettings({ whatsappNumber: cleanNumber });
      } catch (err) {
        console.error('Failed to load settings:', err);
        setSettings({ whatsappNumber: null });
      } finally {
        setLoading(false);
      }
    };
    loadSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ ...settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};